export const faqData = {
  title: "Frequently Asked Questions",
  subtitle:
    "Choose the plan that fits your team’s needs and scale your HR operations with confidence.",

  questions: [
    {
      question: "Is the system suitable for small and large businesses?",
      answer:
        "Yes, the system is designed to scale for both small teams and large enterprises."
    },
    {
      question: "What is the HR Management System?",
      answer:
        "It is a complete platform to manage employees, attendance, payroll, and HR operations."
    },
    {
      question: "Does the system support leave and permission requests?",
      answer:
        "Yes, employees can easily request leave and managers can approve or reject them."
    },
    {
      question: "Can managers manage their teams through the application?",
      answer:
        "Yes, managers can track performance, attendance, and manage team requests."
    },
    {
      question: "Can the system handle payroll and salary management?",
      answer:
        "Yes, it supports automated payroll calculation and salary management."
    },
    {
      question: "Can we request a demo before subscribing?",
      answer:
        "Yes, you can request a demo to explore all features before purchasing."
    },
    {
      question: "Can employees check in and check out using the mobile app?",
      answer:
        "Yes, employees can clock in and out using the mobile application with location tracking."
    },
    {
      question: "Does the system support task management?",
      answer:
        "Yes, tasks can be created, assigned, and tracked within the system."
    },
    {
      question: "Is the system secure and easy to use?",
      answer:
        "Yes, it is built with strong security standards and a user-friendly interface."
    }
  ]
};